export const HOME_PATH = '/';
export const CAPE_PATH = '/capable';
export const FOUR_OH_FOUR = '/*';
// export const FULL_PATH = '/full';
// export const CLIENT_PATH = '/client/:token';
